import { getLocalizedStrings } from '../../loginLocalizedStrings';

class TimeoutTimer extends React.Component {
    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings('loginComponent');
        this.state = {
            timeoutTime: this.strings.timeoutDialog
        };
        this.timeoutTimeInterval = '';
    }

    /*
    * Start Count Down on mount
    */
    componentDidMount() {
        var self = this;
        this.timeoutTimeInterval = setInterval(() => {
            // Update timers in Localstorage
            if(app.appService.getLocalStorage(self.strings.sessionInfo)){
                self.props.updateTimeoutValue();
                let newTime = app.appService.getLocalStorage('Timer') - 1000;
                if (newTime >= 0) {
                    app.appService.setLocalStorage('Timer', newTime);
                    self.setState({ ...self.state, timeoutTime: self.msToTime(app.appService.getLocalStorage('Timer')) });
                } else {
                    if ( app.appService.getLocalStorage('Timer') !== null){
                        clearInterval(this.timeoutTimeInterval);
                        this.props.updateTimedOut();
                    }else{
                        clearInterval(this.timeoutTimeInterval);
                        this.props.onTimeoutDialogExtend();
                        }
                    } 
            }else{
                clearInterval(this.timeoutTimeInterval);
                this.props.updateTimedOut();
            }
        }, 1000);
    }
    /*
    * Milliseconds to Time in text
    */
    msToTime(ms) {
        var mins = Math.floor(ms / 60000);
        var secs = ((ms % 60000) / 1000).toFixed(0);
        return mins + ' minutes and ' + secs + ' seconds';
    }

    render() {
        return (
            <span>{this.state.timeoutTime}</span>
        );
    }
}

export default TimeoutTimer;
